import {
  getNationalNumber,
  NameHelpers,
} from '@principle-theorem/principle-core';
import {
  IMohEnrolmentData,
  IPatient,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { Region, toISODate, WithRef } from '@principle-theorem/shared';
import { MohGenerateEnrolmentForm } from '../../components/moh/moh-generate-enrolment-form-dialog/moh-generate-enrolment-form-dialog.component';
import * as moment from 'moment-timezone';

export class MohEnrolmentPdfDataBuilder {
  static build(
    practice: WithRef<IPractice>,
    patient: WithRef<IPatient>,
    formData: MohGenerateEnrolmentForm
  ): IMohEnrolmentData {
    const patientMobile =
      getNationalNumber(formData.patientMobile, Region.NewZealand) ?? '';
    return {
      agreementHoldersName: formData.agreementHoldersName,
      agreementNumber: formData.agreementNumber,
      changeOfDentalProvider: formData.changeOfDentalProvider,
      districtArea: formData.districtArea,
      newEnrolment: formData.newEnrolment,
      nhiNumber: formData.nhiNumber,
      patientAddress: formData.patientAddress ?? '',
      patientDateOfBirth: formData.patientDateOfBirth,
      patientDayPhoneNumber: formData.patientDayPhoneNumber,
      patientFirstName: NameHelpers.firstName(formData.patientName),
      patientLastName: NameHelpers.lastName(formData.patientName),
      patientGender: patient.gender,
      patientMobile,
      patientOrGuardianName: formData.patientOrGuardianName,
      patientPostcode: formData.patientPostcode,
      patientSchool: patient.metadata?.moh?.school?.schoolName ?? '',
      patientSchoolYear: formData.patientSchoolYear,
      patientSignatureDate: toISODate(moment()),
      payeeNumber: formData.payeeNumber,
      practiceName: practice.name,
      practicePhysicalAddress: formData.practicePhysicalAddress,
      practicePostalAddress: formData.practicePostalAddress,
      signatureDate: toISODate(moment()),
    };
  }
}
